import React from 'react';

const Confirm = (props) => (
  <div>
    <div className="modal-footer border-0 row">
      <button type='button' className="btn btn-primary pointer" disabled={props.confirmed} onClick={() => props.onSubmitAction(null, null)}>ยืนยัน</button>
      <button type='button' className="btn btn-secondary pointer" onClick={props.onCloseModal}>ยกเลิก</button>
    </div>
  </div>
)

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/WorkflowActions/Confirm.js